export default __webpack_public_path__ + "static/digilock-asia-5f275abc30b6173c5705a00821d2d6c3.jpg";